var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgHeaderNotificationIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 25 30",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.5,
    clipPath: "url(#clip0_3668_529)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M15.392 24.2891C15.542 24.6691 15.622 25.0691 15.622 25.4991C15.622 26.4391 15.242 27.2791 14.622 27.8991C14.002 28.5191 13.162 28.8991 12.222 28.8991C10.362 28.8991 8.83203 27.3691 8.83203 25.4991C8.83203 25.0691 8.91203 24.6691 9.06203 24.2891",
    stroke: "#193243",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M23.5811 21.0191C23.5811 21.9191 23.2111 22.7391 22.6211 23.3291C22.0211 23.9191 21.2011 24.2891 20.3011 24.2891H4.15109C2.35109 24.2891 0.871094 22.8191 0.871094 21.0191C0.871094 19.2191 2.35109 17.7391 4.15109 17.7391H4.23109V8.86914C4.23109 4.46914 7.83109 0.869141 12.2311 0.869141C14.4311 0.869141 16.4311 1.76914 17.8811 3.21914C19.3311 4.66914 20.2311 6.66914 20.2311 8.86914V17.7391H20.3011C22.1111 17.7391 23.5811 19.2091 23.5811 21.0191Z",
    stroke: "#193243",
    strokeWidth: 1.75,
    strokeMiterlimit: 10,
    strokeLinecap: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_3668_529"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24.46,
    height: 29.78,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgHeaderNotificationIcon);
export default __webpack_public_path__ + "static/media/headerNotificationIcon.e15fb3747b219005d29f113fc604f33a.svg";
export { ForwardRef as ReactComponent };